import { useTranslation } from "react-i18next";
import { pagesOfSpan, pdfPageUrl, type PageStart } from "./pageMap";

/**
 * Where a segment is in the source PDF: "p. 28 (PDF 30)", linked to the public PDF at that
 * page (ingestion.md IN-6). Nothing when the document has no page map.
 */
export default function SegmentPages({ pages, sourceUrl, start, end }: { pages: readonly PageStart[] | null; sourceUrl: string | undefined; start: number; end: number }) {
  const { t } = useTranslation();
  const span = pages === null ? null : pagesOfSpan(pages, start, end);
  if (span === null) {
    return null;
  }
  const label = (page: PageStart) => (page.label === "" ? t("sources.pages.pdfOnly", { pdf: page.pdfPage }) : t("sources.pages.printed", { page: page.label, pdf: page.pdfPage }));
  const text = span.first.pdfPage === span.last.pdfPage ? label(span.first) : t("sources.pages.range", { first: label(span.first), last: label(span.last) });
  const url = pdfPageUrl(sourceUrl, span.first.pdfPage);
  if (url === null) {
    return <span className="app-text-muted text-xs">{text}</span>;
  }
  return (
    <a href={url} target="_blank" rel="noreferrer noopener" className="app-link text-xs underline" aria-label={t("sources.pages.openPdf", { pages: text })}>
      {text}
    </a>
  );
}
